import { Observable } from 'rxjs';

import { SnIntegration } from '@lib/api/entities';

import { IFsMap } from '../types';

export abstract class FsMapAerisWeatherRadarServiceProvider<TMap extends IFsMap> {
  abstract readonly geospatialProvider: string;
  abstract readonly id: string;

  abstract get isPremium(): boolean;
  abstract onMapLoaded(map: TMap): void;
  abstract addToMap(addtionalLayers?: string[]): void;
  abstract get currentFrame$(): Observable<number>;
  abstract get isAvailable(): boolean;
  abstract removeFromMap(): void;
  abstract getIntegration(): Observable<SnIntegration>;
  abstract reload(): void;
  abstract clearTimers(): void;

  abstract frameCount: number;
  abstract startHours: number;
  abstract endHours: number;
  abstract selectedFrame: number;
  abstract isAnimationPlaying: boolean;
  abstract timer: ReturnType<typeof setTimeout>;
  abstract interval: ReturnType<typeof setInterval>;
}
